/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */
import { NgModule } from '@angular/core';
import { PlatformModule } from '@angular/cdk/platform';
import { MatCommonModule } from '../common-behaviors/common-module';
import { MatRipple } from './ripple';
export { MatRipple, MAT_RIPPLE_GLOBAL_OPTIONS } from './ripple';
export { RippleRef, RippleState } from './ripple-ref';
export { RIPPLE_FADE_IN_DURATION, RIPPLE_FADE_OUT_DURATION } from './ripple-renderer';
export class MatRippleModule {
}
MatRippleModule.decorators = [
    { type: NgModule, args: [{
                imports: [MatCommonModule, PlatformModule],
                exports: [MatRipple, MatCommonModule],
                declarations: [MatRipple],
            },] },
];
/**
 * @nocollapse
 */
MatRippleModule.ctorParameters = () => [];
function MatRippleModule_tsickle_Closure_declarations() {
    /** @type {?} */
    MatRippleModule.decorators;
    /**
     * @nocollapse
     * @type {?}
     */
    MatRippleModule.ctorParameters;
}
//# sourceMappingURL=index.js.map